import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import * as React from 'react';
import withStyles from '../../core/withStyles';
import styles from './Column.styles';
export const Column = ({ className, inline, doubleMargin, flex, classes, children, onClick }, ref) => (_jsx("div", Object.assign({ ref: ref, className: cn(classes.root, inline && classes.inline, doubleMargin && classes.doubleMargin, onClick && classes.clickable, className), style: { flex }, onClick: onClick }, { children: children })));
// @ts-ignore
export default withStyles(styles)(React.forwardRef(Column));
//# sourceMappingURL=Column.js.map